<script>
import useTools from "@/use/Tools";
import useSharedData from "@/use/SharedData";
import {useSecurityStore} from "@/stores/Security";
import {useEmailStore} from "@/stores/Email.js";
import {onMounted, ref} from "vue";
import axios from "axios";

export default {
    setup() {
        const {$i18n, $router} = useTools();

        const {loading, total} = useSharedData();

        const securityStore = useSecurityStore();

        const emailStore = useEmailStore();

        const search = ref(null);

        const headers = [
            {
                text: "...",
                align: "start",
                sortable: false,
                value: "action",
                width: "0px"
            },
            {
                text: $i18n.t("common.name"),
                align: "start",
                sortable: true,
                value: "name",
            },
            {
                text: $i18n.t("common.email"),
                align: "start",
                sortable: true,
                value: "address",
            },
            {
                text: $i18n.t("email.incoming_server"),
                align: "start",
                sortable: true,
                value: "incomingServer",
            },
            {
                text: $i18n.t("email.incoming_port"),
                align: "start",
                sortable: true,
                value: "incomingPort",
            },
            {
                text: $i18n.t("email.outgoing_server"),
                align: "start",
                sortable: true,
                value: "outgoingServer",
            },
            {
                text: $i18n.t("email.outgoing_port"),
                align: "start",
                sortable: true,
                value: "outgoingPort",
            },
        ];

        const actions = [
            {
                title: $i18n.t("common.edit"),
                icon: 'mdi-pencil-box-multiple',
                color: 'orange',
                access: () => securityStore.authorities['UPDATE_GENERAL_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'emails.edit', params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("common.delete"),
                icon: 'mdi-trash-can',
                color: 'red',
                access: () => securityStore.authorities['UPDATE_GENERAL_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'emails.delete', params: {id: item.id}})
                },
            },
        ];

        function findAll() {
            loading.value = true;
            axios.get('/emails').then((response) => {
                emailStore.setEmails(response.data);
                total.value = response.data.length;
            }).finally(() => {
                loading.value = false;
            });
        }

        function view(item) {
            $router.push({name: "emails.view", params: {id: item.id}});
        }

        onMounted(() => findAll());

        return {
            securityStore,
            emailStore,
            loading,
            headers,
            actions,
            search,
            total,
            view,
            findAll,
        }
    },
};
</script>

<template>
    <div>
        <w-app
            :title="$t('module.email')"
            :total="total"
        >
            <template v-slot:rightToolbar>
                <w-btn-reload :loading="loading" @press="findAll"/>
                <w-btn-add
                    :show="securityStore.authorities['UPDATE_GENERAL_PARAM']"
                    @press="$router.push({ name: 'emails.add' })"
                />
            </template>

            <template v-slot:content>
                <v-container fluid>
                    <v-row dense>
                        <v-col cols="4">
                            <w-text-field
                                v-model="search"
                                :label="$t('common.search')"
                            ></w-text-field>
                        </v-col>
                    </v-row>
                </v-container>
                <w-data-table
                    :headers="headers"
                    :actions="actions"
                    :search="search"
                    sort-by="paySectionOrder"
                    :items="emailStore.emails"
                    :total="total"
                    @rowDbClick="view"
                >
                    <template v-slot:[`item.name`]="{ item }">
                        <w-inline-text bold :text="item.name"/>
                    </template>
                    <template v-slot:[`item.address`]="{ item }">
                        <w-inline-text :text="item.address"/>
                    </template>
                    <template v-slot:[`item.incomingServer`]="{ item }">
                        <w-inline-text :text="item.incomingServer"/>
                    </template>
                    <template v-slot:[`item.incomingPort`]="{ item }">
                        <w-chip outlined :text="item.incomingPort"/>
                    </template>
                    <template v-slot:[`item.outgoingServer`]="{ item }">
                        <w-inline-text :text="item.outgoingServer"/>
                    </template>
                    <template v-slot:[`item.outgoingPort`]="{ item }">
                        <w-chip outlined :text="item.outgoingPort"/>
                    </template>
                </w-data-table>
            </template>
        </w-app>
        <router-view/>
    </div>
</template>